export class AlertData {
    constructor({
        id,
        categoryId,
        vesselId,
        title,
        description,
        active,
        lowerLimit,
        upperLimit,
        sendEmail,
        receiverEmail,
    }) {
        this.id = id;
        this.categoryId = categoryId;
        this.vesselId = vesselId;
        this.title = title;
        this.description = description;
        this.active = active;
        this.lowerLimit = lowerLimit;
        this.upperLimit = upperLimit;
        this.sendEmail = sendEmail;
        this.receiverEmail = receiverEmail;
    }

}
